import { IEditPackageTypePayload, IPackageTypeCreate, IPackageTypeListSearch } from "../../../../types/master/packageTypeInterface";
import api from "../../../../lib/api";

export const createPackageTypeApi = async (data: IPackageTypeCreate) => {
  return await api.post(`/package-type`, data);
};

export const getPackageTypeListApi = async (data: IPackageTypeListSearch) => {
  return await api.get(`package-type/${data.page}/${data.pageLimit}?search=${data?.search ?? ""}`);
};

export const getPackageTypeDataByIdApi = async (id: number) => {
  return await api.get(`/package-type/${id}`);
};

export const editPackageTypeDataByIdApi = async (payload: IEditPackageTypePayload) => {
  return await api.put(`/package-type/${payload.id}`, payload.data);
};
